import styled from 'styled-components';
import { ReactComponent as Curve } from '../assets/icons/bg-curve.svg';

interface AuthPageProps {
  isAuth: boolean;
  page: string;
}

export const Wrapper = styled.div<AuthPageProps>`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 92px auto 1fr;
  grid-template-areas:
    'head'
    'container'
    'footer';
  height: 100vh;

  @media screen and (max-width: 960px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto 1fr;
  }
`;

export const Head = styled.div`
  grid-area: head;
  z-index: 1;
`;

export const Container = styled.div<AuthPageProps>`
  grid-area: container;
  z-index: 100;
  background: ${(props) => props.theme.colors.primaryLight};
  min-height: 400px;

  @media screen and (max-width: 960px) {
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -100;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 960px) {
    display: none;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  grid-area: container;
`;

export const CurvedCanvas = styled(Curve)`
  fill: ${(props) => props.theme.colors.primaryLessLight};
  height: 100%;
  min-height: 400px;
  max-height: 790px;
`;
